import {
  defaultLoadableState,
  LoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import React, { createContext, useContext, useMemo } from 'react';
import { SearchSuggestionWithType } from './contracts/SearchSuggestion';

export type SuggestionsContextType = {
  suggestions: LoadableState<SearchSuggestionWithType[]>;
};

const defaultContext: SuggestionsContextType = {
  suggestions: defaultLoadableState<SearchSuggestionWithType[]>([])
};

const SuggestionsContext =
  createContext<SuggestionsContextType>(defaultContext);

export function SuggestionsContextProvider({
  children
}: React.PropsWithChildren) {
  const suggestions = useLoadableState<SearchSuggestionWithType[]>([]);

  const value = useMemo<SuggestionsContextType>(
    () => ({
      suggestions
    }),
    [suggestions]
  );

  return (
    <SuggestionsContext.Provider value={value}>
      {children}
    </SuggestionsContext.Provider>
  );
}

export default SuggestionsContext;

export function useSuggestionsContext() {
  return useContext(SuggestionsContext);
}
